
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsUI": { "availability": { "awayMessage": { "defaultMessageText": "We're away right now, but we'll get back to you as soon as we can." }, "outsideOfficeHoursMessage": { "defaultMessageText": "We're away right now, but we'll get back to you as soon as we can." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-schema": {
    "cs": "static-2.2846",
    "da": "static-2.2846",
    "de": "static-2.2846",
    "el": "static-2.2846",
    "en": "static-2.2846",
    "es-mx": "static-2.2846",
    "es": "static-2.2846",
    "fi": "static-2.2846",
    "fr": "static-2.2846",
    "it": "static-2.2846",
    "ja": "static-2.2846",
    "ko": "static-2.2846",
    "nl": "static-2.2846",
    "no": "static-2.2846",
    "pl": "static-2.2846",
    "pt-br": "static-2.2846",
    "sv": "static-2.2846",
    "zh-cn": "static-2.2846",
    "zh-hk": "static-2.2846"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsUI": { "default": { "firstName": "Unknown", "lastName": "Visitor", "messageName": "Default Message", "meetingsLinkText": "Schedule some time with me", "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "visitorText": "Can you go into a bit more detail about your pricing structure?", "awayMessage": "I'm away at the moment, but let me know if you have any questions and I'll reply to you soon.", "name": "New Message ({{timeStamp}})", "qualifiedLead": { "initialMessage": "Hi there! I'm happy to help you today." }, "initialMessage": "Got any questions? I'm happy to help.", "askForEmailMessage": "Don’t have time to wait for a response? Leave your email to get notified when we reply." }, "validationError": { "availability": "You must choose a time.", "customAwayMessage": { "required": "Away message is required", "tooLong": "Away message is too long." }, "targetAudienceId": "Please choose a value.", "targetAudienceType": "Please choose a target audience.", "inclusionUrls": "Please enter at least one valid web page URL.", "exclusionUrls": "Please enter a valid web page URL.", "name": "Please enter a valid name for this message.", "emptyUrl": "Please enter a valid web page URL.", "meetingsLinkText": "Please enter display text for your meetings link.", "meetingsLinkId": "You must choose a meetings link to display.", "fallbackUser": "Please choose a team member.", "emptyName": "Please name your message.", "emptyNameTooltip": "Please name your message to continue.", "emptyMessage": "Please enter a message.", "accentColor": "Please enter a valid Hex color code.", "sendFromError": "Please choose at least one user or team." }, "typicalResponseTime": { "standardResponses": { "FEW_MINUTES": "We typically reply in a few minutes", "FEW_HOURS": "We typically reply in a few hours", "WITHIN_DAY": "We typically reply in a day" }, "customResponses": { "MINUTES": "We typically reply in {{ num }} minutes", "HOURS": "We typically reply in {{ num }} hours", "DAYS": "We typically reply in {{ num }} days" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-schema": {
    "en": "static-2.2846"
  }
};
  result.translationsAvailable = {
  "conversations-schema": {
    "cs": "static-2.2846",
    "da": "static-2.2846",
    "de": "static-2.2846",
    "el": "static-2.2846",
    "en": "static-2.2846",
    "es-mx": "static-2.2846",
    "es": "static-2.2846",
    "fi": "static-2.2846",
    "fr": "static-2.2846",
    "it": "static-2.2846",
    "ja": "static-2.2846",
    "ko": "static-2.2846",
    "nl": "static-2.2846",
    "no": "static-2.2846",
    "pl": "static-2.2846",
    "pt-br": "static-2.2846",
    "sv": "static-2.2846",
    "zh-cn": "static-2.2846",
    "zh-hk": "static-2.2846"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-schema:en', {version: 'static-2.2846'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "uiAddonAvatars": { "defaultUploader": { "title": "Upload a photo", "confirm": "Confirm", "cancel": "Cancel", "alerts": { "imageTooBig": { "title": "File too big", "text": "Please upload a smaller one" }, "apiError": { "title": "Something went wrong", "text": "Please try again later" } } } }, "ui": { "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" } }, "salesUI": { "UIAbstractDateInput": { "invalidDate": "Invalid date", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "placeholder": "Select a range", "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDateRangeInputs": { "invalidDateRange": "Please select an end date that isn't before the given start date" }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIHelpButton": { "clickForHelp": "Click for help" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading…" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" } }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option “{{label}}”", "plusMore": "+ {{count}} more", "andMore": "…and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITableSortToggle": { "ascendingSort": "Ascending sort", "descendingSort": "Descending sort", "noSort": "No sort" }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITextArea": { "characterCounter": { "one": "{{count}} character", "other": "{{count}} characters" } }, "UITextToolbarButton": { "remove": "Remove {{name}}", "noop": "You can't {{name}} the current selection" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-2.1755"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "cs": "static-2.1755",
    "da": "static-2.1755",
    "de": "static-2.1755",
    "el": "static-2.1755",
    "en": "static-2.1755",
    "es-mx": "static-2.1755",
    "es": "static-2.1755",
    "fi": "static-2.1755",
    "fr": "static-2.1755",
    "it": "static-2.1755",
    "ja": "static-2.1755",
    "ko": "static-2.1755",
    "nl": "static-2.1755",
    "no": "static-2.1755",
    "pl": "static-2.1755",
    "pt-br": "static-2.1755",
    "sv": "static-2.1755",
    "zh-cn": "static-2.1755",
    "zh-hk": "static-2.1755"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-2.1755'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsUI": { "email": { "header": { "emailToHeader": "{{ from }} to {{ to }}" }, "infoTable": { "to": "To", "from": "From", "cc": "cc", "bccKey": "bcc", "date": "Date", "subject": "Subject" }, "replies": { "hide": "Collapse", "show": "View Trimmed Content" }, "statusFooter": { "initializing": { "label": "Initializing" }, "sending": { "label": "Sending" }, "sent": { "label": "Sent" }, "bounced": { "label": "We couldn't deliver this message.", "description": "The message was sent but not delivered. Please check the recipient's email address and try again." }, "error": { "label": "Unable to send message.", "description": "Something went wrong. Please try again." }, "failed": { "label": "Unable to send message.", "description": "Something went wrong. Please try again." } } }, "thread-deletion": { "restoreMessageLink": "Restore message", "messageDeleted": "This message has been deleted. {{ restoreMessageLink }}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.5219",
    "da": "static-1.5219",
    "de": "static-1.5219",
    "el": "static-1.5219",
    "en": "static-1.5219",
    "es-mx": "static-1.5219",
    "es": "static-1.5219",
    "fi": "static-1.5219",
    "fr": "static-1.5219",
    "it": "static-1.5219",
    "ja": "static-1.5219",
    "ko": "static-1.5219",
    "nl": "static-1.5219",
    "no": "static-1.5219",
    "pl": "static-1.5219",
    "pt-br": "static-1.5219",
    "sv": "static-1.5219",
    "zh-cn": "static-1.5219",
    "zh-hk": "static-1.5219"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "CrmTicketLifecycleUpdates": { "createdBy": { "system": "<b>New {{threadType}} automatically</b> created ticket <b>{{ticketName}}</b>", "currentAgent": "<b>You</b> created ticket <b>{{ticketName}}</b>", "agent": "<b>{{agent}}</b> created ticket <b>{{ticketName}}</b>" }, "updatedBy": { "system": "Ticket status changed to {{pipelineStage}} {{dateString}}", "currentAgent": "Ticket status changed to {{pipelineStage}} by you {{dateString}}", "agent": "Ticket status changed to {{pipelineStage}} by {{agent}} {{dateString}}" }, "threadTypes": { "EMAIL": "email", "LIVE_CHAT": "chat", "FB_MESSENGER": "message" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.5219",
    "da": "static-1.5219",
    "de": "static-1.5219",
    "el": "static-1.5219",
    "en": "static-1.5219",
    "es-mx": "static-1.5219",
    "es": "static-1.5219",
    "fi": "static-1.5219",
    "fr": "static-1.5219",
    "it": "static-1.5219",
    "ja": "static-1.5219",
    "ko": "static-1.5219",
    "nl": "static-1.5219",
    "no": "static-1.5219",
    "pl": "static-1.5219",
    "pt-br": "static-1.5219",
    "sv": "static-1.5219",
    "zh-cn": "static-1.5219",
    "zh-hk": "static-1.5219"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsUI": { "chat": { "emailCapture": { "responseText": "Visitor submitted their email: {{ email }}" }, "responders": { "bot": "Bot", "unknown": "Unknown visitor" }, "urlMarker": "<b>Chatting from:</b> <a href={{url}} target='_blank'>{{url}}</a>", "visitorAway": "{{ visitorName }} left the page and may not see new messages right away.", "closedConversation": "Conversation closed {{ dateString }}", "dateStringWithAgo": "{{ dateString }} ago", "dateStringWithOn": "on {{ dateString }}", "assignmentLabels": { "roundRobin": "{{ assignee }} was automatically assigned to this conversation {{ dateString }}", "roundRobinYou": "You were automatically assigned to this conversation {{ dateString }}", "manualAssignment": "{{ assignor }} assigned this conversation to {{ assignee }} {{ dateString }}", "manualAssignmentAssigneeThemselves": "{{ assignor }} assigned this conversation to themselves {{ dateString }}", "manualAssignmentAssignorYou": "You assigned this conversation to {{ assignee }} {{ dateString }}", "manualAssignmentAssigneeYou": "{{ assignor }} assigned this conversation to you {{ dateString }}", "manualAssignmentYourself": "You assigned this conversation to yourself {{ dateString }}", "leadQualifierBot": "{{ assignee }} was assigned to this conversation by a lead qualifier bot {{ dateString }}", "leadQualifierBotYou": "You were assigned to this conversation by a lead qualifier bot {{ dateString }}", "unassignment": "This conversation has been unassigned", "unknownResponder": "Unknown user" }, "status": { "PUBLISHED": "Sent ", "UNPUBLISHED": "Sending... ", "PUBLISH_FAILED": "Not delivered. Click to retry." }, "welcomeMessage": "Welcome message", "inboxMessageStatus": { "UNPUBLISHED": "Sending... ", "PUBLISHED": "<b>Sent</b><span class=\"m-x-1\">•</span>{{timestamp}}", "READ": "<b>Read</b><span class=\"m-x-1\">•</span>{{timestamp}}", "PUBLISH_FAILED": "Not delivered. Click to retry." }, "messageSentTimestampTooltip": "Sent at {{timestamp}}", "welcomeMessageTooltip": "A welcome message is a prompt used to invite your website visitors to start a conversation.", "commentMessageSubject": "{{ name }} left a comment {{ timestamp }}" }, "adminAccessRequired": "Please contact your administrator for edit access.", "GDPR": { "toggleLabel": "Apply GDPR to this targeted message", "help": "<a href='https://www.hubspot.com/data-privacy/gdpr/hubspot-product-playbook' target='_blank'>Learn more</a>", "consentToProcess": { "label": "Consent to process data", "help": "Use the text field below to explain why you need to store and process your customer's personal information." }, "consentToCommunicate": { "default": "I agree to receive other communications from {{ accountName }}", "label": "Consent to communicate", "help": "Use the text field below to tell customers what type of communication they're consenting to." } }, "emailCapture": { "placeholderText": "Enter email address", "errorMessage": "You entered an invalid email.", "successMessage": "Thanks. You'll be notified of our response here and by email.", "knownVisitorFollowUpMessage": "You'll be notified of our response here and by email.", "maintenanceModeMessage": "You'll be notified of our response by email.", "outsideOfficeHoursMessage": "Leave your email to get notified when we reply." }, "officeHours": { "willReturnAt": "We'll return {{ dayAndTime }}", "defaultMessageText": "We'll return tomorrow at 9:00 AM" }, "typicalResponseTime": { "standardResponses": { "FEW_MINUTES": "We typically reply in a few minutes", "FEW_HOURS": "We typically reply in a few hours", "WITHIN_DAY": "We typically reply in a day" }, "customResponses": { "MINUTES": "We typically reply in {{ num }} minutes", "HOURS": "We typically reply in {{ num }} hours", "DAYS": "We typically reply in {{ num }} days" } }, "chatArea": { "branding_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Add free ",
createElement( options,
"Link",
props,
"live chat" ),
" to your site" ); } }, "chatTextArea": { "validationMessage": "Message is too long.", "placeholder": "Write a message", "offlinePlaceholder": "Network issue detected." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ui-addon-conversations": {
    "en": "static-1.5219"
  }
};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.5219",
    "da": "static-1.5219",
    "de": "static-1.5219",
    "el": "static-1.5219",
    "en": "static-1.5219",
    "es-mx": "static-1.5219",
    "es": "static-1.5219",
    "fi": "static-1.5219",
    "fr": "static-1.5219",
    "it": "static-1.5219",
    "ja": "static-1.5219",
    "ko": "static-1.5219",
    "nl": "static-1.5219",
    "no": "static-1.5219",
    "pl": "static-1.5219",
    "pt-br": "static-1.5219",
    "sv": "static-1.5219",
    "zh-cn": "static-1.5219",
    "zh-hk": "static-1.5219"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-conversations:en', {version: 'static-1.5219'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsUI": { "errorAlert": { "titleText": "Something went wrong.", "message_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Please try again. If it keeps happening, ",
createElement( options,
"Link",
{ onClick: props.onClick },
"let us know" ),
"." ); }, "eventId": "Event Id: {{ eventId }}" }, "zeroState": { "noChannels": { "title": "Get the conversations flowing", "firstBody": "Having multiple conversations at once just got easy. Wherever they're happening - live chat or email - keep track of them here, in one place.", "secondBody": "At a glance, get a full conversation history and the details of the person you're chatting with, and assign it to the right team member. Ready to go?", "createEmail": "Connect my team email", "createChat": "Connect chat" } }, "name": "Live Chat", "inbox": { "customAwayMessage": { "defaultMessageText": "We're away for the moment, but we'll get back to you as soon as we can!" } }, "inboxes": { "saveButton": "Save", "cancelButton": "Cancel", "createEditHeader": "Create Inbox", "updateEditHeader": "Edit Inbox" }, "welcome": { "title": "Chat with site visitors, right when they're most engaged.", "body": "Messages lets you target the right people at the right time, and chat with them while they browse your website. It's the easiest way to turn site visitors into qualified leads.", "create": "Create Message" }, "messageNamePrompt": { "placeholder": "Ex: Pricing page message" }, "loadingState": { "header": "Loading conversations", "errorLineOne": "Something's gone wrong.", "errorLineTwo": "Refresh the page or log in again.", "errorLineThree": "If this keeps happening, please contact support." }, "unknownVisitor": "Unknown visitor", "chat": { "thisVisitor": "This visitor", "zeroState": { "title": "You don’t have any chats that match the current filters", "description": "Keep this window open to stay online and receive notifications when your next live chat begins", "customMessage": "Create a custom message inviting website visitors to chat with you live.", "createMessage": "Create message" } }, "alerts": { "SEND_RECONNECT_EMAIL_SUCCESS": { "title": "Success!", "description": "Your email request has been sent." }, "SEND_RECONNECT_EMAIL_FAILED": { "title": "Sorry", "description": "Your email could not be sent at this time. Please try again later." }, "RECONNECT_ACCOUNT_SUCCESS": { "title": "Success", "description": "{{ email }} has been successfully reconnected" }, "TICKET_CREATE_FAILED": { "title": "Unable to create ticket", "description": "Please try again." }, "TICKET_CREATE_SUCCESS": { "title": "Success.", "description": "Ticket created." }, "PERMISSION_RETRY_FAILED": { "title": "Retry Failed", "description": "Please click \"{{ helpLink }}\" for help." }, "EDIT_SUCCEEDED": { "title": "Changes saved", "description": "Edits to your message have been saved" }, "EDIT_FAILED": { "title": "Save error", "description": "Edits to your message weren't saved" }, "SETTINGS": { "title": "Changes saved", "description": "Settings have been saved" }, "SETTINGS_FAILED": { "title": "Save error", "description": "Edits to your settings weren't saved" }, "NEW_MESSAGE": { "title": { "one": "You have {{ count }} new message.", "other": "You have {{ count }} new messages." }, "description": "Open conversation" }, "EMBED_CODE_EMAIL": { "title": "Email sent", "description": "The embed code has been sent to {{ email }}" }, "INTEGRATION_INSTALL_FAILED": { "title": "{{ integrationName }} didn't connect.", "description": "Please try again, or contact support if it keeps happening." }, "INTEGRATION_UNINSTALL_FAILED": { "title": "{{ integrationName }} didn't disconnect.", "description": "Please try again, or contact support if it keeps happening." }, "INTEGRATION_SETTINGS_UPDATE_SUCCEEDED": { "title": "Changes saved.", "description": "Your {{ integrationName }} settings have been saved." }, "INTEGRATION_SETTINGS_UPDATE_FAILED": { "title": "Your {{ integrationName }} settings couldn't be saved.", "description": "Please try again, or contact support if it keeps happening." }, "pubNubStatus": { "visiblyOffline": { "title": "Sorry. There was a network connection issue. ", "description": "Please wait a few seconds and try again." }, "PNNetworkUpCategory": { "title": "The network connection issue is resolved.", "description": "You're successfully reconnected to messages." }, "PNRsubscribeLimitReached": { "title": "Sorry. We’re currently unable to connect you to messages.", "description": "Please refresh your page." } }, "newMessage": { "title": "You have a new message.", "description": "Click {{ link }} to go to message." } }, "default": { "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "meetingsLinkText": "Schedule some time with me" }, "input": { "availability": { "description": "Choose when you'd like to be shown as online and offline." }, "chatButtons": { "insertLabel": "Insert:", "snippetsButton": "Snippet" }, "chatArea": { "branding": "Not using {{ messagesLink }} yet?", "messages": "HubSpot" }, "chatTextArea": { "validationMessage": "Message is too long.", "placeholder": "Write a message", "offlinePlaceholder": "Network issue detected." }, "email": { "error": "You entered an invalid email." }, "embedCodeInputSelector": { "link": "How do I install the tracking code?" }, "embedCodeEmailForm": { "title": "Need someone else to install the code?", "description": "Email the code snippet to your web developer or admin.", "placeholder": "Enter email address", "error": "Please enter a valid email address." }, "widgetCustomization": { "tooltip": { "text": "Your avatar can be updated in your {{ link }}", "link": "HubSpot Profile Settings.", "preview": "Preview" }, "header": { "launcher": "Closed launcher style", "accent": "Accent Color", "branding": "HubSpot Branding", "tooltip": "We recommend choosing a color that contrasts against the background of your site, so that your customers can clearly see how to get in touch with you." }, "preview": { "header": "Preview" }, "switch": { "OPEN": "Open", "CLOSED": "Closed", "OFFICE_HOURS": "Office hours", "REPLY_TIME": "Reply time", "LAUNCHER": "Launcher", "preview": "Preview" }, "description": { "launcher": "Choose whether you'd like your avatar or a chat icon to be shown.", "branding": "Show HubSpot branding on your messages chat window." } }, "brandColorPicker": { "description": "Customize your chat window accent color to match your brand." }, "launcherPicker": { "use": "use {{ type }}", "types": { "AVATAR": "avatar", "ICON": "icon" } } }, "buttons": { "open": "Open <b>({{ count }})</b>", "closed": "Closed <b>({{ count }})</b>", "blocked": "Blocked <b>({{ count }})</b>", "backToTargetedMessages": "Back to targeted messages", "saveChanges": "Save", "cancel": "Cancel", "send": "Send" }, "settings": { "pendingChanges": { "one": "You've changed {{ count }} setting.", "other": "You've changed {{ count }} settings." } }, "emailCapture": { "placeholderText": "Enter email address", "errorMessage": "You entered an invalid email.", "successMessage": "Thanks. You'll be notified of our response here and by email.", "knownVisitorFollowUpMessage": "You'll be notified of our response here and by email.", "maintenanceModeMessage": "You'll be notified of our response by email.", "outsideOfficeHoursMessage": "Leave your email to get notified when we reply.", "defaultAwayEmailCaptureMessage": "What email address should we use to follow up?" }, "officeHours": { "defaultMessageText": "We'll return tomorrow at 9:00 AM" }, "access-control": { "admin-only-banner": { "title": "Only administrators can edit these settings.", "description": "Ask an account administrator to request a change." } }, "GDPR": { "toggleLabel": "Apply GDPR to this targeted message", "help": "<a href='https://www.hubspot.com/data-privacy/gdpr/hubspot-product-playbook' target='_blank'>Learn more</a>", "consentToProcess": { "label": "Consent to process data", "help": "Use the text field below to explain why you need to store and process your customer's personal information." }, "consentToCommunicate": { "default": "I agree to receive other communications from {{ accountName }}", "label": "Consent to communicate", "help": "Use the text field below to inform customers what type of communication they're consenting to." } }, "sendDisconnectedAccountEmailPrompt": { "title": "Ask an admin to reconnect email", "body": "Send an email to an account administrator asking them to reconnect <strong>{{ email }}</strong>", "confirm": "Send", "cancel": "Cancel", "placeholder": "Select administrator" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.4354",
    "da": "static-1.4354",
    "de": "static-1.4354",
    "el": "static-1.4354",
    "en": "static-1.4354",
    "es-mx": "static-1.4354",
    "es": "static-1.4354",
    "fi": "static-1.4354",
    "fr": "static-1.4354",
    "it": "static-1.4354",
    "ja": "static-1.4354",
    "ko": "static-1.4354",
    "nl": "static-1.4354",
    "no": "static-1.4354",
    "pl": "static-1.4354",
    "pt-br": "static-1.4354",
    "sv": "static-1.4354",
    "zh-cn": "static-1.4354",
    "zh-hk": "static-1.4354"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsUI": { "messagePreview": { "error": { "title": "Something went wrong previewing this message.", "description": "Please try again, or contact support if this keeps happening." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.4354",
    "da": "static-1.4354",
    "de": "static-1.4354",
    "el": "static-1.4354",
    "en": "static-1.4354",
    "es-mx": "static-1.4354",
    "es": "static-1.4354",
    "fi": "static-1.4354",
    "fr": "static-1.4354",
    "it": "static-1.4354",
    "ja": "static-1.4354",
    "ko": "static-1.4354",
    "nl": "static-1.4354",
    "no": "static-1.4354",
    "pl": "static-1.4354",
    "pt-br": "static-1.4354",
    "sv": "static-1.4354",
    "zh-cn": "static-1.4354",
    "zh-hk": "static-1.4354"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsVisitorUIAvailability": { "sameDay": "We'll return today at {{time}}", "nextDay": "We'll return tomorrow at {{time}}", "nextWeek": "We'll return {{dayOfWeek}} at {{time}}" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.4354",
    "da": "static-1.4354",
    "de": "static-1.4354",
    "el": "static-1.4354",
    "en": "static-1.4354",
    "es-mx": "static-1.4354",
    "es": "static-1.4354",
    "fi": "static-1.4354",
    "fr": "static-1.4354",
    "it": "static-1.4354",
    "ja": "static-1.4354",
    "ko": "static-1.4354",
    "nl": "static-1.4354",
    "no": "static-1.4354",
    "pl": "static-1.4354",
    "pt-br": "static-1.4354",
    "sv": "static-1.4354",
    "zh-cn": "static-1.4354",
    "zh-hk": "static-1.4354"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "cvVisitorUIAttachments": { "errors": { "fileSizeExceeded": "File exceeds the {{maxSize}} max upload.", "blacklistedExtension": "That file type is not allowed.", "uploadError": "Unable to upload attachment." }, "tryAgain": "Try again", "threadPreview": "An attachment has been sent" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.4354",
    "da": "static-1.4354",
    "de": "static-1.4354",
    "el": "static-1.4354",
    "en": "static-1.4354",
    "es-mx": "static-1.4354",
    "es": "static-1.4354",
    "fi": "static-1.4354",
    "fr": "static-1.4354",
    "it": "static-1.4354",
    "ja": "static-1.4354",
    "ko": "static-1.4354",
    "nl": "static-1.4354",
    "no": "static-1.4354",
    "pl": "static-1.4354",
    "pt-br": "static-1.4354",
    "sv": "static-1.4354",
    "zh-cn": "static-1.4354",
    "zh-hk": "static-1.4354"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "New Message" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.4354",
    "da": "static-1.4354",
    "de": "static-1.4354",
    "el": "static-1.4354",
    "en": "static-1.4354",
    "es-mx": "static-1.4354",
    "es": "static-1.4354",
    "fi": "static-1.4354",
    "fr": "static-1.4354",
    "it": "static-1.4354",
    "ja": "static-1.4354",
    "ko": "static-1.4354",
    "nl": "static-1.4354",
    "no": "static-1.4354",
    "pl": "static-1.4354",
    "pt-br": "static-1.4354",
    "sv": "static-1.4354",
    "zh-cn": "static-1.4354",
    "zh-hk": "static-1.4354"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "visitorWidget": { "header": { "threadListTitle": "Conversations" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-internal-components": {
    "cs": "static-1.4266",
    "da": "static-1.4266",
    "de": "static-1.4266",
    "el": "static-1.4266",
    "en": "static-1.4266",
    "es-mx": "static-1.4266",
    "es": "static-1.4266",
    "fi": "static-1.4266",
    "fr": "static-1.4266",
    "it": "static-1.4266",
    "ja": "static-1.4266",
    "ko": "static-1.4266",
    "nl": "static-1.4266",
    "no": "static-1.4266",
    "pl": "static-1.4266",
    "pt-br": "static-1.4266",
    "sv": "static-1.4266",
    "zh-cn": "static-1.4266",
    "zh-hk": "static-1.4266"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-internal-components": { "code-splitting": { "error": { "title": "There was a network connection issue.", "message": "Please check your connection and try again.", "button": "Try again" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-internal-components": {
    "cs": "static-1.4266",
    "da": "static-1.4266",
    "de": "static-1.4266",
    "el": "static-1.4266",
    "en": "static-1.4266",
    "es-mx": "static-1.4266",
    "es": "static-1.4266",
    "fi": "static-1.4266",
    "fr": "static-1.4266",
    "it": "static-1.4266",
    "ja": "static-1.4266",
    "ko": "static-1.4266",
    "nl": "static-1.4266",
    "no": "static-1.4266",
    "pl": "static-1.4266",
    "pt-br": "static-1.4266",
    "sv": "static-1.4266",
    "zh-cn": "static-1.4266",
    "zh-hk": "static-1.4266"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "cvInternalComponentsAttachments": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} of {{totalBytes}}" }, "fileSizeLimit": "{{size}} max upload" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-internal-components": {
    "cs": "static-1.4266",
    "da": "static-1.4266",
    "de": "static-1.4266",
    "el": "static-1.4266",
    "en": "static-1.4266",
    "es-mx": "static-1.4266",
    "es": "static-1.4266",
    "fi": "static-1.4266",
    "fr": "static-1.4266",
    "it": "static-1.4266",
    "ja": "static-1.4266",
    "ko": "static-1.4266",
    "nl": "static-1.4266",
    "no": "static-1.4266",
    "pl": "static-1.4266",
    "pt-br": "static-1.4266",
    "sv": "static-1.4266",
    "zh-cn": "static-1.4266",
    "zh-hk": "static-1.4266"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsInternalComponents": "" } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-internal-components": {
    "en": "static-1.4266"
  }
};
  result.translationsAvailable = {
  "conversations-internal-components": {
    "cs": "static-1.4266",
    "da": "static-1.4266",
    "de": "static-1.4266",
    "el": "static-1.4266",
    "en": "static-1.4266",
    "es-mx": "static-1.4266",
    "es": "static-1.4266",
    "fi": "static-1.4266",
    "fr": "static-1.4266",
    "it": "static-1.4266",
    "ja": "static-1.4266",
    "ko": "static-1.4266",
    "nl": "static-1.4266",
    "no": "static-1.4266",
    "pl": "static-1.4266",
    "pt-br": "static-1.4266",
    "sv": "static-1.4266",
    "zh-cn": "static-1.4266",
    "zh-hk": "static-1.4266"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-internal-components:en', {version: 'static-1.4266'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor": "BethBot requires that at least one key be defined in this file", "conversationsUI": { "buttons": { "agree": "I agree" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-visitor-ui": {
    "en": "static-1.4354"
  }
};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.4354",
    "da": "static-1.4354",
    "de": "static-1.4354",
    "el": "static-1.4354",
    "en": "static-1.4354",
    "es-mx": "static-1.4354",
    "es": "static-1.4354",
    "fi": "static-1.4354",
    "fr": "static-1.4354",
    "it": "static-1.4354",
    "ja": "static-1.4354",
    "ko": "static-1.4354",
    "nl": "static-1.4354",
    "no": "static-1.4354",
    "pl": "static-1.4354",
    "pt-br": "static-1.4354",
    "sv": "static-1.4354",
    "zh-cn": "static-1.4354",
    "zh-hk": "static-1.4354"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-visitor-ui:en', {version: 'static-1.4354'}); }
})();








//////////////////
// WEBPACK FOOTER
// ./bundles/visitor-before.js?no-parse&sporks
// module id = 1998
// module chunks = 